module.exports = __webpack_public_path__ + "static/media/eth.790d94ab.png";